module.exports = __webpack_public_path__ + "static/media/intro-message-resized.46117fac.jpg";